import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Account } from "model";
/**
* @class MobileNickname
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.userActivities[0];
* const device = new MobileNickname(record);
* @property {NUMBER} _id - The id of the userActivity.
* @property {BCMSDate} _date - The date of the userActivity.
* @property {String} _time - The time of the userActivity.
* @property {UserActivityCategory} _category - The category of the userActivity.
*
* @description When a new "Account" is created in the model xml, 
* create a "mobileNickname" entry in the model xml as well.
* This is probably how the actual product works since the user 
* can't create a "Mobile Nickname" in the product,
* but they have access to mobile nickname entries they can edit.
* 
*/

export default class MobileNickname extends BCMSRecord {
    _id
    _account
    _nickname
    _enabled
    _primary
    
    constructor (record){     
      super( record  ) 
    }
  }
MobileNickname.define({
    "recordType":"mobileNicknames",
    "recordIDProp":"id",
    "className" : "MobileNickname",
    "recordProperties":[
        /** 
         * @name id
         * @instance
         * @property get {NUMBER} - gets the id of the userActivity
         * @property set {NUMBER} - sets the id of the userActivity
         * @memberof MobileNickname
         */
        BCMSRecordProperty.mapToNumber("id", "_id", "id"),

        /** 
         * @name account
         * @instance
         * @property get {Account} - gets the account referenced
         * @property set {Account} - sets the account referenced
         * @memberof MobileNickname
         */
        BCMSRecordProperty.mapToClass("account", "_account", () => Account),

        /** 
         * @name nickname
         * @instance
         * @property get {Account} - gets the nickname
         * @property set {Account} - sets the nickname
         * @memberof MobileNickname
         */
        BCMSRecordProperty.mapToString("nickname", "_nickname", "nickname"),

        /** 
         * @name enabled
         * @instance
         * @property get {Boolean} - gets the enabled value
         * @property set {Boolean} - sets the enabled value
         * @memberof MobileNickname
         */
        BCMSRecordProperty.mapToBoolean("enabled", "_enabled", "enabled"),

        /** 
         * @name primary
         * @instance
         * @property get {Boolean} - gets the primary value
         * @property set {Boolean} - sets the primary value
         * @memberof MobileNickname
         */
        BCMSRecordProperty.mapToBoolean("primary", "_primary", "primary"),

      ]
})




